import { runResourceSync } from "services/sync/engine";
import { POLICY } from "services/sync/policies";
import EmployeesService from 'services/employees.service';
import ChatService from 'services/chat.service';
import { normalize } from 'models/conversation.model'

export function agent({ syncEngine, scope, repository, repositories, params, cached, onCall, onFinally, force }) {
  const { lineId, userId } = params;
  return runResourceSync(syncEngine, scope, `(lineId:${lineId})-(userId:${userId})`, {
    cached,
    repository,
    onCall,
    onFinally,
    fetchRemote: () => EmployeesService.getAssignedChats(lineId),
    selectItems: (response) => response.payload.chats,
    mapItems: (items) => items.map(normalize),
    scopeIndex: 'lineId_userId',
    scopeValue: [lineId, userId],
    policy: POLICY.EVENT,
    force,
  });
};

export function supervisor({ syncEngine, scope, repository, repositories, params, cached, onCall, onFinally, force }) {
  const { lineId, userId } = params;
  return runResourceSync(syncEngine, scope, `(lineId:${lineId})-(userId:${userId})`, {
    cached,
    repository,
    onCall,
    onFinally,
    fetchRemote: () => EmployeesService.getAgentChats(lineId, userId),
    selectItems: (response) => response.payload.chats,
    mapItems: (items) => items.map(normalize),
    mode: "mirror",
    scopeIndex: 'lineId_userId',
    scopeValue: [lineId, userId],
    policy: POLICY.EVENT,
    force,
  });
};

export function expired({ syncEngine, scope, repository, repositories, params, cached, onCall, onFinally, force }) {
  const { userId, status } = params;
  return runResourceSync(syncEngine, scope, `(status:${status})`, {
    cached,
    repository,
    onCall,
    onFinally,
    fetchRemote: () => ChatService.getExpired(),
    selectItems: (response) => response.payload.chats,
    mapItems: (items) => items.map(normalize),
    mode: "mirror",
    scopeIndex: 'status',
    scopeValue: status,
    scopeFilter: (conversations) => {
      return conversations.filter((conversation) => {
        return conversation?.userId === userId;
      });
    },
    policy: POLICY.EVENT,
    force
  });
};

export function unassigned({ syncEngine, scope, repository, repositories, params, cached, onCall, onFinally, force }) {
  const { status } = params;
  return runResourceSync(syncEngine, scope, `(status:${status})`, {
    cached,
    repository,
    onCall,
    onFinally,
    fetchRemote: () => ChatService.getUnassigned(),
    selectItems: (response) => response.payload.chats,
    mapItems: (items) => items.map(normalize),
    mode: "mirror",
    scopeIndex: 'status',
    scopeValue: status,
    policy: POLICY.EVENT,
    force
  });
};